// import Vue from 'vue'
import * as types from './mutationTypes'

export default {
  [types.UPDATE_CHANNEL] (state, channel) {
    state.channel = channel
  },
  [types.UPDATE_CHANNEL_ID] (state, channel_id) {
    state.channel_id = channel_id
  },
  [types.UPDATE_PAGE] (state, page) {
    state.page = page
  },
  [types.UPDATE_PAGES] (state, pages) {
    state.pages = pages
  },
  [types.UPDATE_PAGE_ID] (state, page_id) {
    state.page_id = page_id
  },
  [types.UPDATE_PAGE_TITLE] (state, content) {
    console.log(content)
    // Vue.set(state.channel.pages, content)
  },
  [types.UPDATE_TIER] (state, tier) {
    if (!state.channel.tiers) state.channel.tiers = {}
    state.channel.tiers[tier.name] = tier
  },
  [types.UPDATE_TIERS] (state, tiers) {
    state.tiers = tiers
  },
  [types.UPDATE_USER] (state, user) {
    state.user = user
  },
  [types.CONFIRM_DELETE] (state, id) {
    state.confirm_delete_page = id
  },
  [types.PAGE_DELETED] (state) {
    state.confirm_delete_page = null
  },
  [types.UPDATE_FANS] (state, fans) {
    state.fans = fans
  }
}
